var TopicSelectorSerialiser = require('topics/topic-selector-serialiser');
var CIDSerialiser = require('conversation/conversation-id-serialiser');
var SessionSerialiser = require('session/session-id-serialiser');

module.exports = {
    read : function(input) {
        var sessionID = SessionSerialiser.read(input);
        var selector = TopicSelectorSerialiser.read(input);
        var cid = CIDSerialiser.read(input);

        return {
            sessionID : sessionID,
            selector : selector,
            cid : cid
        };
    },
    write : function(output, req) {
        SessionSerialiser.write(output, req.sessionID);
        TopicSelectorSerialiser.write(output, req.selector);
        CIDSerialiser.write(output, req.cid);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/missing-topic/missing-topic-request-serialiser.js
// module id = 1692
// module chunks = 1